module.exports = __webpack_public_path__ + "media/images/p-about/can/purchase-a74d5242fa1614b68f7b26c1804def79.svg";